import { LogoMark } from "@/components/suffa/Ornaments";
import { OrnamentDivider } from "@/components/suffa/Ornaments";
import RegistrationPaymentCard from "./RegistrationPaymentCard";
import { useLanguage } from "@/lib/i18n";
import { useOffer } from "@/lib/offer";

const SubmissionSuccess = () => {
  const { t } = useLanguage();
  const offer = useOffer();
  return (
  <div className="cp-container">
    <section className="cp-card cp-success" data-testid="cp-success">
      <a href="/" className="auth-logo" aria-label="Suffa Matrimony home">
        <LogoMark size={44} />
      </a>
      <div className="auth-ornament" aria-hidden="true">
        <OrnamentDivider />
      </div>
      <h1 className="cp-success-title" data-testid="cp-success-title">
        {t("Profile Completed")}
      </h1>
      <p className="cp-success-text" data-testid="cp-success-text">
        {t(
          "Your profile has been completed and saved securely to your Suffa Matrimony account.",
        )}
      </p>
      <p className="cp-success-sub" data-testid="cp-success-fee">
        {t(offer && offer.active ? "One-time Profile Registration Fee: ₹400" : "One-time Profile Registration Fee: ₹500")}
      </p>
      <RegistrationPaymentCard payLabel={t("Pay ₹500 & Submit Profile")} />
      <p className="cp-success-sub">
        {t(
          "It will appear in Find Matches for other members, subject to Suffa Matrimony's approval and privacy rules. Our team will reach out to you on your preferred contact method, insha’Allah.",
        )}
      </p>
      <div className="cp-success-actions">
        <a href="/my-profile" className="btn btn-solid btn-lg" data-testid="cp-success-my-profile">
          {t("Go to My Profile")}
        </a>
        <a href="/" className="btn btn-outline btn-lg" data-testid="cp-success-home">
          {t("Back to Home")}
        </a>
      </div>
    </section>
  </div>
  );
};

export default SubmissionSuccess;
